import { IAttachment } from "./Chat.model";

export interface IChatMessage {
  isSeen: boolean;
  direction: string;
  sender: {
    userId: string;
    name: string;
  };
  message: string;
  createdAt: string;
  _id: string;
  status: string;
}

export interface IChat {
  _id: string;
  receiver: string;
  chats: Record<string, IChatMessage>;
  sender: {
    userId: string;
    name: string;
  };
  isSeen?: boolean;
}

export interface IChatProps {
  chatId: string;
  chat: {
    id: string;
    phoneNumber: string;
    sender: {
      userId: string;
      name: string;
    };
  };
  initialMessages: IMessage[];
  onBackClick?: () => void;
}

export interface IMessage {
  isSeen: boolean;
  messageId: any;
  id?: string;
  content: string;
  timestamp: Date;
  sender: {
    userId: string;
    name: string;
  };
  isIncoming: boolean;
  isLoading?: boolean;
  status: string;
  attachments?: IAttachment[];}

export enum IMessageDirection {
  Sending = "Sending",
  Receiving = "Receiving",
}

export enum IMessageStatus {
  Sending = "sending",
  Sent = "sent",
  Delivered = "delivered",
  Read = "read",
  Failed = "failed",
}
